import React, { useEffect, useState, useRef } from 'react';
import * as Constants from './../../constants'
import Button from '../../components/reusableElementsComponents/Button';
import { InputAdornment } from '@mui/material';
import { Toast } from 'primereact/toast';
import { FormControl, TextField } from '@mui/material';
import mazharLogo from "../../assets/images/logos/apex_analytics_green_logo.svg";
import B2BApiService from '../../B2bApiService';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import AuthPageChrome from '../../components/layoutComponents/authComponents/AuthPageChrome';
import { useLocale } from '../../locale';
import { t } from '../../content';

function SetPassword() {
    const { withLocale } = useLocale();
    const api = new B2BApiService();
    const myToast = useRef(null);
    const showToast = (severityValue, summaryValue, detailValue) => {
        myToast.current.show({ severity: severityValue, summary: summaryValue, detail: detailValue });
    }
    const [password, setPassword] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [error, setError] = useState(false);
    const [token, setToken] = useState("")

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const accessToken = query.get('key')
        setToken(accessToken)
    }, [])

    useEffect(() => {
        if (password.length !== 0) {
            if (password === confirmPassword) {
                setDisabled(false)
            }
            else {
                setDisabled(true)
            }
        }
        else {
            setDisabled(true)
        }

    }, [password, confirmPassword])

    const handleBlur = () => {
        let valid = Constants.VALID_PASSWORD.test(password)
        // eslint-disable-next-line
        let validReconfirm = Constants.VALID_PASSWORD.test(confirmPassword)
        if (valid) {
            setError(false)
        }
        else {
            setError(true)
        }
    }

    const handleClick = () => {

        api.SetNewPassword({ key: token, password: password }).then(response => {
            if (response.httpStatus === 200) {
                showToast('success', t('toasts.successMessage'), t('toasts.mailSent'))
                setTimeout(() => {
                    window.location.href = withLocale('/login')
                }, 2000)
            }
        })

    }

    return (
        <div className="help-center center-content">
            <AuthPageChrome logoSrc={mazharLogo} />
            <br />
            <h3>{t('auth.setPassword.title')}</h3>
            <br />
            <div style={{ width: "600px", background: "#fff", padding: "30px", borderRadius: "5px", display: "flex", justifyContent: "center", flexDirection: "column" }}>
                <Toast ref={myToast} />
                <FormControl style={{ width: "100%" }}>
                    <TextField
                        placeholder={t('common.placeholders.enterNewPassword')}
                        id="password"
                        name="password"
                        type={passwordVisible ? "text" : "password"}
                        autoComplete="on"
                        value={password}
                        onBlur={handleBlur}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <button type="button" onClick={() => setPasswordVisible(!passwordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                        {passwordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </button>
                                </InputAdornment>
                            ),
                        }}
                        variant="standard"
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </FormControl>
                {error &&
                    <div>
                        <p style={{ color: "red" }}>{Constants.VALID_PASSWORD_INSTRUCTION}</p>
                    </div>
                }
                <br />
                <FormControl style={{ width: "100%" }}>
                    <TextField
                        placeholder={t('common.placeholders.confirmPassword')}
                        id="passwordconfirmation"
                        name="password"
                        type={confirmPasswordVisible ? "text" : "password"}
                        autoComplete="on"
                        value={confirmPassword}
                        onBlur={handleBlur}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <button type="button" onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                        {confirmPasswordVisible ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                    </button>
                                </InputAdornment>
                            ),
                        }}
                        variant="standard"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </FormControl>
                {disabled && confirmPassword.length !== 0 &&
                    < div >
                        <p style={{ color: "red" }}>
                            Both Passwords Must Match
                        </p>
                    </div>
                }
                <br />

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button btnstyle={disabled ? 'mazhrBtn default upper mar-25 top' : 'mazhrBtn default-green upper mar-25 top'} onClick={handleClick} disabled={disabled} >{t('common.actions.submit')}</Button>
                </div>

            </div>

        </div >
    )
}
export default SetPassword
